import React from 'react';

const FrameComponent5 = () => {
  return (

    <div id='text-container' className='flex flex-col text-center font-cormorant-garamond bg-white h-[120%] gap-y-5 pb-5 px-2'>
      <h1 id='title' className='text-21xl   mq450:text-15xl mq800:text-17xl  mq1125:text-20xl text-gray-400'>Квалифицированные юридические услуги в сфере граждан?</h1>
      <p id='info1' className='tracking-wider text-2xl text-gray-200 font-outfit leading-8'>Мы не будем говорить вам о том, что вы не можете делать.</p>
      <p id='info2' className='tracking-wider text-2xl text-gray-200 font-outfit leading-8'>Мы расскажем вам, как именно сделать то, что вы хотите.</p>
    </div>


  );
};

export default FrameComponent5; 
